import { render, staticRenderFns } from "./NewsIndexUser.vue?vue&type=template&id=5d24dd47"
import script from "./NewsIndexUser.vue?vue&type=script&lang=js"
export * from "./NewsIndexUser.vue?vue&type=script&lang=js"
import style0 from "./NewsIndexUser.vue?vue&type=style&index=0&id=5d24dd47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports